module.exports = __webpack_public_path__ + "static/media/Registry_Kitchen_Tabletop@2x.7b5dd91e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/registry/Registry_Kitchen_Tabletop@2x.jpg
// module id = 2597
// module chunks = 70